<template>
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="16rem">
    <el-form-item label="播放次数">
      <el-input-number v-model="ruleForm.PlayRule" :min="1"></el-input-number>
    </el-form-item>
    <el-form-item label="播放文字">
      <el-input
        type="textarea"
        v-model="ruleForm.SettingContent"
        style="width: 79rem"
      ></el-input>
    </el-form-item>
    <el-form-item label="关联设备" style="margin-top: 1.2rem">
      <div
        class="bgcolor"
        style="
          display: inline-block;
          width: 79rem;
          height: 30rem;
          overflow: auto;
          padding: 10px;
        "
      >
        <el-checkbox-group v-model="CheckedResources">
          <el-checkbox
            v-for="item in Devices"
            :label="item.DeviceId"
            :key="item.DeviceId"
            >{{ item.DeviceName }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
    </el-form-item>
  </el-form>
</template>
<script>
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";
import broApis from "../../../../../broadcast/src/apis";
const utils = ZJApp.ZJUtils;
export default {
  name: "ZjComponentradioDetail",
  controller: "UI",
  action: "ComponentradioDetail",
  props: {
    PlanTaskId: String,
    TaskSubTypeId: String,
  },
  data() {
    return {
      ruleForm: {
        SettingTitle: "",
        SettingContent: "",
        PlayRule: "",
        Resources: [],
      },
      Devices: [],
      PlayRuleoptions: [],
      CheckedResources: [],
    };
  },
  created: function () {
    this.showLoading("加载中...");
    let searchInfo = {
      EquipmentType: "Broadcast",
      PageSize: 1000,
      PageIndex: 1,
      TotalCount: 0,
      StartNumber: 0,
      EndNumber: 0,
    };
    utils
      .waitAll([
        new broApis.TranResourcesApi().GetEquipmentPagingList(searchInfo),
        //TODO: 调用关联屏幕接口
      ])
      .then((r) => {
        let data = r[0].data.Data;
        if (data) {
          this.Devices = data.PageContents;
        }
        this.hideLoading();
        this.search();
        return r;
      })
      .catch((e) => {
        console.error(e);
        this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        this.hideLoading();
      });
  },
  methods: {
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    showLoading(text) {
      this.$emit("loading", text);
    },
    hideLoading() {
      this.$emit("loadingFinish");
    },
    search() {
      let PlanTaskId = this.$props.PlanTaskId;
      //let TaskSubTypeId=this.$props.TaskSubTypeId;
      if (PlanTaskId != null && PlanTaskId != "") {
        let searchInfo = {
          PlanTaskId: PlanTaskId,
          TaskSubTypeId: "EmergencyTaskType.Communication.Broadcast",
          PageSize: 20,
          PageIndex: 1,
          TotalCount: 0,
          StartNumber: 0,
          EndNumber: 0,
        };
        this.showLoading("加载中...");
        new MyApis.PlantasksettingApi()
          .FindByConditions(searchInfo)
          .then((r) => {
            var data = r.data.Data;
            if (data.length > 0) {
              this.ruleForm = data[0];
              new MyApis.PlantaskreceiverApi()
                .FindByConditions({
                  TaskSettinId: data[0].SettingId,
                })
                .then((r) => {
                  var data = r.data.Data;

                  this.CheckedResources = [];
                  data.forEach((item) => {
                    this.CheckedResources.push(item.ReceiverId);
                  });
                  //  this.existingReceivers = data;
                  this.hideLoading();
                })
                .catch((e) => {
                  console.error(e);
                  this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
                  this.hideLoading();
                });
            }
            this.hideLoading();
          })
          .catch((e) => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.hideLoading();
          });
      }
    },
    Gettaskreceiver() {
      var tasksett = {};
      var receivers = [];

      tasksett.OrgId = this.user.Departments[0].OrgId;
      //tasksett.SettingId = utils.uuid();
      tasksett.PlanTaskId = this.PlanTaskId;
      tasksett.PlayRule = this.ruleForm.PlayRule;
      tasksett.SettingContent = this.ruleForm.SettingContent;
      tasksett.TaskSubTypeId = this.TaskSubTypeId;
      this.CheckedResources.forEach((item) => {
        var receobj = {};
        receobj.OrgId = this.user.Departments[0].OrgId;
        receobj.TaskSettinId = tasksett.SettingId;
        receobj.TaskSubTypeId = this.TaskSubTypeId;
        receobj.ReceiverId = item;
        receivers.push(receobj);
      });

      return { TaskSettingDTO: tasksett, TaskReceiverDTO: receivers };
    },
  },
};
</script>